module.exports = __webpack_public_path__ + "static/media/coprose-logo.f9e51ef0.png";